import React from 'react';
import { PhoneMockup } from '@/components/PhoneMockup';
import { PLAY_STORE_URL } from '@/lib/constants';
export function HeroSection() {
  return (
    <section className="awayfx-hero relative min-h-screen flex items-center overflow-x-hidden bg-[#FEF7FF] dark:bg-[#0D0B12] pt-[72px]">
      {/* Glows */}
      <div className="hero-glow-primary absolute top-[-10%] right-[-5%] w-[55%] h-[85%] rounded-full pointer-events-none" />
      <div className="hero-glow-secondary absolute bottom-[-18%] left-[-5%] w-[45%] h-[70%] rounded-full pointer-events-none" />

      <div className="max-w-[1200px] mx-auto px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center py-20">
          {/* Text */}
          <div className="relative z-10">
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
              <div className="inline-flex items-center gap-2 mb-7 px-3.5 py-1.5 rounded-full text-[13px] font-semibold tracking-wide bg-[#EADDFF] text-[#21005D] dark:bg-[#2C1F45] dark:text-[#EADDFF] dark:border dark:border-[#D0BCFF]/20">
                <span className="w-1.5 h-1.5 rounded-full bg-[#6750A4] dark:bg-[#D0BCFF]"
                  style={{ animation: 'glow-pulse 2s ease-in-out infinite' }} />
                Material 3 · Privacy First
              </div>
            </div>
            <h1 className="animate-in fade-in slide-in-from-bottom-4 duration-700 delay-100 text-[clamp(52px,6vw,80px)] font-extrabold tracking-[-0.04em] leading-none text-[#6750A4] dark:text-m3-dark-primary mb-4">
              AwayFX
            </h1>
            <p className="animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200 text-[clamp(26px,3vw,40px)] font-semibold tracking-[-0.025em] leading-[1.15] text-[#1D1B20] dark:text-white mb-5">
              FX for when you&apos;re away.
            </p>
            <p className="animate-in fade-in slide-in-from-bottom-4 duration-700 delay-300 text-lg leading-[1.65] text-[#625B71] dark:text-[#D8D1DD] max-w-[440px] mb-10 lg:mb-20 font-normal">
              A minimalist, privacy first currency converter for Android. No ads, no tracking. Just fast, reliable exchange rates, whenever you&apos;re away.
            </p>
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-700 delay-500 flex flex-col sm:flex-row items-center sm:items-start gap-3">
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get AwayFX on Google Play"
                className="group inline-flex items-center gap-2.5 px-7 py-3.5 rounded-full text-base font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_32px_-8px_rgba(103,80,164,0.5)]"
                style={{ background: '#6750A4' }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <polygon points="6 3 20 12 6 21 6 3" />
                </svg>
                Get it on Google Play
              </a>
              <span className="inline-flex items-center px-4 py-3.5 text-sm font-medium text-[#625B71] dark:text-[#D8D1DD]">
                Free · No ads · No tracking
              </span>
            </div>
          </div>
          {/* Phone */}
          <div className="animate-in fade-in zoom-in-95 duration-700 delay-300 flex justify-center items-center relative z-10">
            <div className="w-[280px]" style={{ animation: 'phone-float 4s ease-in-out infinite' }}>
              <PhoneMockup imageUrl="/screenshots/screen1.png" alt="AwayFX converter screen showing a EUR to AUD conversion" imageScale={0.965} />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .hero-glow-primary {
          background: radial-gradient(ellipse, rgba(103,80,164,0.14) 0%, transparent 70%);
          animation: glow-pulse 5s ease-in-out infinite;
        }
        .hero-glow-secondary {
          background: radial-gradient(ellipse, rgba(234,221,255,0.5) 0%, transparent 70%);
        }
        .dark .awayfx-hero .hero-glow-primary {
          background: radial-gradient(ellipse, rgba(208,188,255,0.18) 0%, rgba(103,80,164,0.08) 38%, transparent 72%);
          opacity: 0.78;
        }
        .dark .awayfx-hero .hero-glow-secondary {
          background: radial-gradient(ellipse, rgba(103,80,164,0.16) 0%, rgba(208,188,255,0.055) 42%, transparent 74%);
          opacity: 0.58;
        }
        @keyframes glow-pulse { 0%,100%{opacity:.35;transform:scale(1)} 50%{opacity:.55;transform:scale(1.06)} }
        @keyframes phone-float { 0%,100%{transform:translateY(-6px)} 50%{transform:translateY(6px)} }
      `}</style>
    </section>
  );
}
